import axios from 'axios'
import { AuthObject } from '@/types'

const API_URL: string = '/api/auth/'

class AuthService {
  async login(credentials: AuthObject) {
    return axios.post(`${API_URL}signin`, credentials).then(response => {
      if (response.data.accessToken) {
        localStorage.setItem('user', JSON.stringify(response.data))
      }
      return response.data
    })
  }

  logout() {
    localStorage.removeItem('user')
  }
}

export default new AuthService()
